<template>
  <v-alert
      dismissible
      :type="$store.state.alert.type"
      :class="($vuetify.breakpoint.mobile) ? 'alert alert-mobile' : 'alert'"
      v-model="$store.state.alert.show">
    <h5 class="mb-0">
      {{$store.state.alert.message}}
    </h5>
  </v-alert>
</template>

<script>
export default {
  name: 'AlertMessage'
}
</script>

<style scoped lang="sass">
.alert
  z-index: 9999
  width: 30%
  top: 80px
  right: 20px
  position: fixed
  &.alert-mobile
    top: 60px
    left: 0
    width: 100%
</style>
